import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-new-employer-accept-tc",
    prompt: "Welcome to Ameriflex! For each step of your onboarding experience, you will find instructions in this panel to assist you. " 
        + "If a step has additional information, click on the ? icon on the right. " 
        + "Your Ameriflex Contact will also be in touch soon to offer additional support. ",
    briefDescription: 'Accept T&C',
    details: "For this step, review your order form below, <strong>click 'Agree'</strong> to agree to the Terms & Conditions</strong> for the new plan year, then click <strong>'I am done - Next'</strong> on the right.",
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
    },
    openAction: { 
            text: "Go To Your Order Form",
            url: (guidanceItem) => `/employer/${guidanceItem.employerId}/order/${guidanceItem.orderId}`
        },
    completeAction: {}
});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-new-employer-accept-tc.js